import $ from 'jquery';

import Vars from '../../vars';
import Polygon from "../classes/Polygon";
import Utils from "../../components/utils";
import Modal from "../../components/Modal";
import Request from "../../components/request";

class Facade {
    constructor(args) {
        let self = this;

        self._setArgs(args);
        self._init(args);
    }

    _elems = {
        $_     : $(),
        $modal : $(),
        $form  : $()
    };

    _const = {
        entities : 'facades',
        entity   : 'facade',
        title    : {
            add  : 'Разметка секций (подъездов) на изображении дома',
            edit : 'Разметка секций (подъездов) на изображении дома'
        }
    };

    _state = {
        map            : {},
        unusedPolygons : {},
        usedPolygons   : {}
    };

    _args = {
        mode     : '',
        item     : {},
        object   : {},
        building : {},
        section  : {},
        done     : function(){},
        update   : function(){}
    };

    _setArgs = (args) => {
        let self = this;

        self._args.mode     = args.mode;
        self._args.item     = args.item;
        self._args.section  = args.section || self._args.section;
        self._args.building = args.building || self._args.building;
        self._args.object   = Object.keys(self._args.building).length && self._args.building.object ? self._args.building.object : self._args.object;
        self._args.done     = args.done;
        self._args.update   = args.update;

        self._elems.$_      = args.root;
    };

    _getAvailableSections = (args) => {
        let  self = this;

        let polygon = args.polygon;

        return self._args.building.sections.map(function(section, section_index) {
            return {
                id     : section.id,
                index  : section_index,
                name   : section.name,
                number : section.number
            };
        }).filter(function(section) {
            if (polygon.section_id == section.id) return true;

            return !self._state.map.getPolygons().some(function(current_polygon) {
                return section.id === current_polygon.section_id;
            });
        })
    };

    _getAvailableFloors = (args) => {
        let self = this;

        let polygon = args.polygon;

        return (Object.keys(self._args.section).length ? Array(self._args.section.count_of_floors).join('.').split('.').map(function(nothing, floor_index) {
            return self._args.section.floors[self._args.section.count_of_floors - floor_index - 1];
        }) : []).filter(function(floor) {
            if (polygon.floor_id == floor.id) return true;

            return !self._state.map.getPolygons().some(function(current_polygon) {
                return floor.id === current_polygon.floor_id;
            });
        });
    };

    _initPolygon = (args) => {
        let self   = this;

        let done   = args.done;

        let $modal = new Modal({
            title   : 'Настройка полигона',
            content : Utils.renderProfileTemplate(self._const.entity + '-polygon-form', {
                object              : self._args.object,
                building            : Object.keys(self._args.building).length ? self._args.building : null,
                section             : Object.keys(self._args.section).length ? self._args.section : null,
                polygon             : args.polygon,
                available_sections  : args.availableSections,
                available_floors    : args.availableFloors,
                type                : self._args.mode
            }),
            closingConfirmation: true,
            confirm : function(args) {
                let $modal = args.modal;

                if ($('body').hasClass('_exit_fullscreen')) {
                    let facadeMap = document.getElementById('facade-form-map');
                    if(facadeMap.webkitRequestFullScreen) facadeMap.webkitRequestFullScreen();
                    else if(facadeMap.mozRequestFullScreen) facadeMap.mozRequestFullScreen();
                    else if(facadeMap.requestFullscreen) facadeMap.requestFullscreen();

                    $('body').removeClass('_exit_fullscreen');
                }

                let $facadePolygonSectionId = $modal.find('[name="facade_polygon[section_id]"]');
                let $facadePolygonFloorId   = $modal.find('[name="facade_polygon[floor_id]"]');

                done && done({
                    modal          : $modal,
                    facade_polygon : {
                        section_id : ($facadePolygonSectionId.length > 0 ? parseInt($facadePolygonSectionId.val()) : undefined),
                        floor_id   : ($facadePolygonFloorId.length > 0 ? parseInt($facadePolygonFloorId.val()) : undefined),
                    }
                });

                $modal.trigger('close');
            }
        });

        setTimeout(function(){
            $modal.find('select').focus();

            if ($('body').hasClass('_fullscreen')){
                if (document.webkitExitFullscreen) document.webkitExitFullscreen(); // Chrome, Opera, Safari
                else if (document.mozCancelFullScreen) document.mozCancelFullScreen(); // Firefox
                else if (document.msExitFullscreen) document.msExitFullscreen(); // Internet Explorer, Edge
                else if (document.exitFullscreen) document.exitFullscreen();

                $('body').addClass('_exit_fullscreen');
            }
        }, 300);

        $modal.find('.button--remove').click(function(e) {
            e.preventDefault();
            args.delete && args.delete({
                modal : $modal
            });
        });
    };

    _initModal = () => {
        let self = this;

        self._elems.$modal = new Modal({
            title   : Object.keys(self._args.item).length ? self._const.title.edit : self._const.title.add,
            content : Utils.renderProfileTemplate(self._const.entity + '-form', {
                object               : self._args.object,
                building             : self._args.building,
                section              : Object.keys(self._args.section).length ? self._args.section : null,
                type                 : self._args.mode,
                [self._const.entity] : self._args.item
            }),
            closingConfirmation : true,
            confirm : function(args) {
                let $modal = args.modal;
                if (!$modal.length) return;
                let $form = $modal.find('form');
                if (!$form.length) return;

                Request.send({
                    path   : '/api/objects/' + self._args.object.id + '/buildings/' + self._const.entities + '/' + (Object.keys(self._args.item).length ? self._args.item.id + '/edit' : 'create'),
                    method : 'POST',
                    data   : $form.serialize() + '&' + $.param({
                        facade: {
                            polygons : [].concat(self._state.unusedPolygons).concat(self._state.map.getPolygons().map(function(polygon) {
                                return {
                                    coordinates: 	polygon.getGeometry().getCoordinates()[0],
                                    section_id: 	polygon.section_id,
                                    floor_id: 		polygon.floor_id
                                };
                            })).filter(function(polygon) {
                                if (Object.keys(self._args.section).length) return polygon.section_id == self._args.section.id && polygon.floor_id !== undefined ? true : false;
                                return polygon.floor_id === undefined ? true : false;
                            })
                        },
                        section_id: Object.keys(self._args.section).length ? self._args.section.id : undefined
                    }),
                    done: function(response) {
                        loader.decrease();

                        if (response.error) {
                            // self.profile.callback.error(response.error, form);
                            return;
                        }

                        self._args.item = response[self._const.entity];
                        self._args.done && self._args.done(response);
                        $modal.trigger('close');
                    }
                });
            }
        });

        self._elems.$form = self._elems.$modal.find('form');

        self._state.usedPolygons = self._args.item.polygons.filter(function(polygon) {
            if (Object.keys(self._args.section).length) return polygon.section_id === self._args.section.id && polygon.floor_id !== undefined;
            return polygon.floor_id === undefined;
        });
        self._state.unusedPolygons = self._args.item.polygons.filter(function(polygon) {
            return self._state.usedPolygons.indexOf(polygon) < 0;
        });

        self._state.map = new Polygon({
            image: {
                path   : self._args.item.path_to_extra_large !== '' ? self._args.item.path_to_extra_large : self._args.item.path_to_original,
                width  : self._args.item.width,
                height : self._args.item.height
            },
            polygons : self._state.usedPolygons,
            background_polygons: self._state.unusedPolygons.filter(function(unusedPolygon) {
                if (Object.keys(self._args.section).length && self._args.section.id === unusedPolygon.section_id) return true;
                return false;
            }),
            target   : self._const.entity + '-form-map',
            events   : {
                created: function (polygon) {
                    self._initPolygon({
                        polygon            : polygon,
                        availableSections  : self._getAvailableSections({polygon: polygon}),
                        availableFloors    : self._getAvailableFloors({polygon: polygon}),
                        done               : function (args) {
                            polygon.section_id 	= Object.keys(self._args.section).length ? self._args.section.id : args.facade_polygon.section_id;
                            polygon.floor_id 	= args.facade_polygon.floor_id;

                            args.modal.trigger('close');
                        },
                        delete             : function (args) {
                            self._state.map.deletePolygon(polygon);

                            args.modal.trigger('close');
                        }
                    });
                },
                clicked : function (polygon) {
                    self._initPolygon({
                        polygon            : polygon,
                        availableSections  : self._getAvailableSections({polygon: polygon}),
                        availableFloors    : self._getAvailableFloors({polygon: polygon}),
                        done               : function (args) {
                            polygon.section_id 	= Object.keys(self._args.section).length ? self._args.section.id : args.facade_polygon.section_id;
                            polygon.floor_id 	= args.facade_polygon.floor_id;

                            args.modal.trigger('close');
                        },
                        delete             : function (args) {
                            self._state.map.deletePolygon(polygon);

                            args.modal.trigger('close');
                        }
                    });
                },
                pointerdrag: function () {
                    //self.modal.allow_container_closing = false;
                },
                moveend: function () {
                    //self.modal.allow_container_closing = true;
                }
            }
        });
    };

    _bindUI = () => {
        let self    = this;

        self._elems.$_.find('.dz-link').unbind('update').on('update', function(e) {
            self._args.item = self._args.update();
        });

        self._elems.$_.find('.dz-link').unbind('click').on('click', function(e) {
            e.preventDefault();

            if (self._args.mode == Vars.view.building && (!Object.keys(self._args.building).length || !self._args.building.sections.length)){
                new Modal({
                    title : 'Разметка секций на изображении дома',
                    content : Utils.renderProfileTemplate('info', {
                        message : 'Пожалуйста, добавьте хотя бы одну секцию перед тем, как начать разметку секций на изображении дома.',
                        buttons : {
                            one: {
                                class: 'confirm button--edit',
                                title: 'Хорошо'
                            }
                        }
                    })
                });
                return;
            }
            else if (self._args.mode == Vars.view.section && !Object.keys(self._args.section).length){
                new Modal({
                    title : 'Разметка этажей на изображении секции',
                    content : Utils.renderProfileTemplate('info', {
                        message : 'Для разметки этажей на изображении секции необходимо предварительно сохранить добавляемую секцию.',
                        buttons : {
                            one: {
                                class: 'confirm button--edit',
                                title: 'Хорошо'
                            }
                        }
                    })
                });
                return;
            }

            self._initModal();
        });
    };

    _init = () => {
        let self = this;

        self._bindUI();
    };
}

export default Facade;